import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { instanceAPIPrivate } from 'config/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const getWinnerMessage = createAsyncThunk(
  'winnerMessage',
  async (postData) => {
    const winnerMessageData = await instanceAPIPrivate.post(
      '/pre-validation-winner',
      postData,
      axiosConfig,
    )
      .then((resp) => resp.data)
      .catch((err) => err.response.data);
    return winnerMessageData;
  },
);

const winnerMessageSlice = createSlice({
  name: 'winnerMessage',
  initialState: {
    winnerMessageData: {},
    winnerMessageStatus: '',
  },
  extraReducers: {
    [getWinnerMessage.pending]: (state) => {
      state.winnerMessageStatus = 'loading';
    },
    [getWinnerMessage.fulfilled]: (state, action) => {
      state.winnerMessageStatus = 'success';
      state.winnerMessageData = action.payload;
    },
    [getWinnerMessage.rejected]: (state, action) => {
      state.winnerMessageStatus = 'error';
      state.winnerMessageData = action.payload;
    },
  },
});

export default winnerMessageSlice.reducer;
